import React from 'react'
import Modal from 'react-modal'
import axios from 'axios'
import InputMask from 'react-input-mask'
import { useHistory } from 'react-router-dom'
import { useAuthDispatch } from 'context'
import { loginUser } from 'context/actions'
import { useState } from 'react'
import { Formik, Form, Field } from 'formik'
import { Loader } from 'components/loader/loader'
import { TimedBtn } from 'components/timer'

Modal.setAppElement('#root')

const Input = (props) => (
  <InputMask
    mask="999999"
    value={props.value}
    maskChar={null}
    onChange={props.onChange}
    placeholder={'СМС-код'}
  >
    {(inputProps) => {
      return (
        <Field
          {...inputProps}
          type="text"
          autoComplete="one-time-code"
          inputMode="numeric"
          name="code"
          className={props.className}
        />
      )
    }}
  </InputMask>
)

export const SmsModal = ({
  phone,
  isNew,
  nextStep,
  expired,
  setExpired,
  isOpen,
  setIsOpen,
}) => {
  const hiddenPhone = phone.slice(0, -4) + '****'
  const dispatch = useAuthDispatch()
  const history = useHistory()
  const [trigger, setTrigger] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [errorSend, setErrorSend] = useState('')

  const smsCode = () => {
    return axios
      .post(`${process.env.REACT_APP_BACKEND}/auth/authenticate`, {
        phone,
      })
      .then((e) => [setExpired(5), setTrigger(!trigger)])
  }

  const customStyles = {
    overlay: {
      backgroundColor: 'rgba(47, 128, 237, 0.5)',
      position: 'fixed',
      display: 'flex',
      justifyContent: 'center',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      zIndex: 9,
      overflowY: 'auto',
    },
    content: {
      position: 'absolute',
      backgroundColor: '#FFFFFF',
      borderRadius: '10px',
      height: 'fit-content',
      margin: '10px auto',
      maxWidth: '540px',
      width: '95%',
      outlineWidth: 0,
    },
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => {
        setIsOpen(false)
      }}
      overlayClassName={'modal_overlay'}
      className={'modal'}
      style={customStyles}
      contentLabel="Авторизация"
      shouldCloseOnOverlayClick={true}
    >
      <div className="modal__phone">
        <h2 className="modal__title">Авторизация</h2>
        <div className="modal__wrap">
          <div className="modal__subtitle">
            Введите полученный на номер {hiddenPhone} СМС код.
          </div>
          <Formik
            initialValues={{ code: '' }}
            validate={(values) => {
              const errors = {}
              if (!values.code) {
                errors.code = 'Обязательное поле'
              }
              if (values.code && values.code.length < 6) {
                errors.code = 'Не правильный формат кода'
              }

              return errors
            }}
            onSubmit={async (values, { setSubmitting }) => {
              setIsLoading(true)
              try {
                if (!isNew) {
                  return await loginUser(dispatch, {
                    code: values.code,
                    phone: phone,
                  })
                    .then((response) => {
                      response.user
                        ? history.push('/profile')
                        : setErrorSend(response.message)
                    })
                    .catch((e) => console.log(e))
                }
                return await loginUser(dispatch, {
                  code: values.code,
                  phone: phone,
                })
                  .then((response) => {
                    response.user ? nextStep() : setErrorSend(response.message)
                  })
                  .catch((e) => {
                    setErrorSend('Телефон пользователя или код не совпадают.')
                  })
              } catch (error) {
                console.log(error)
              }
              setIsLoading(false)
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              isValid,
              handleSubmit,
              isSubmitting,
            }) => (
              <Form
                className="authorization__form authorization__form_3 js-authorization2step-form"
                onSubmit={handleSubmit}
                autoComplete={'off'}
              >
                {errorSend ? (
                  <>
                    <hr />
                    <div className="sendvote__simpletext">{errorSend}</div>
                    <div className="sendvote__input-button to-right">
                      <button
                        className="sendvote__btn-submit button"
                        onClick={() => {
                          setErrorSend('')
                          setIsLoading(false)
                        }}
                      >
                        <span>Повторить</span>
                      </button>
                    </div>
                  </>
                ) : (
                  <div className="authorization__input-group sms">
                    <div className="authorization__input-block">
                      <label htmlFor="phone">6 символов из смс</label>
                      <Input
                        autoComplete={'off'}
                        className={errors.code ? 'input error' : 'input'}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.code}
                        disabled={isLoading}
                      />
                      <span className="authorization__error">
                        {errors.code && touched.code && errors.code}
                      </span>
                    </div>
                    <div className="authorization__input-block">
                      <div className="authorization__repeat-btn">
                        {!isLoading && (
                          <TimedBtn
                            initialMinute={expired}
                            trigger={trigger}
                            onClick={smsCode}
                          />
                        )}
                      </div>
                    </div>
                    <div className="authorization__input-group buttons">
                      <div className="authorization__input-button">
                        <button
                          className="btn btn-clean authorization__btn-submit button"
                          type="button"
                          onClick={() => {
                            setIsOpen(false)
                          }}
                        >
                          <span>отменить</span>
                        </button>
                      </div>
                      <div className="authorization__input-button">
                        <button
                          className="btn btn-red authorization__btn-submit button"
                          type="submit"
                          disabled={!isValid || isLoading}
                        >
                          {isLoading && <Loader />}
                          <span style={{ opacity: isLoading ? 0 : 1 }}>
                            Войти
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </Modal>
  )
}
